<template>
  <div class="online-statistics">
    <!-- 搜索区域 -->
    <el-card class="search-card" shadow="never">
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="店铺">
          <el-select v-model="searchForm.storeId" placeholder="请选择店铺" clearable filterable style="width: 200px;">
            <el-option
              v-for="store in stores"
              :key="store.id"
              :label="store.storename"
              :value="store.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="searchForm.timeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 380px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch" :loading="searchLoading" :disabled="searchLoading">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset" :disabled="searchLoading">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 总览卡片 -->
    <el-row :gutter="20" class="summary-cards">
      <el-col :span="6">
        <el-card shadow="hover" class="summary-card">
          <div class="card-icon current-online">
            <i class="el-icon-user"></i>
          </div>
          <div class="card-content">
            <div class="card-title">当前在线</div>
            <div class="card-value">{{ summary.currentOnline }}</div>
            <div class="card-unit">人</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="summary-card">
          <div class="card-icon today-peak">
            <i class="el-icon-top"></i>
          </div>
          <div class="card-content">
            <div class="card-title">今日峰值</div>
            <div class="card-value">{{ summary.todayPeak }}</div>
            <div class="card-unit">人</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="summary-card">
          <div class="card-icon today-total">
            <i class="el-icon-s-data"></i>
          </div>
          <div class="card-content">
            <div class="card-title">今日总数</div>
            <div class="card-value">{{ summary.todayTotal }}</div>
            <div class="card-unit">人</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="summary-card">
          <div class="card-icon avg-duration">
            <i class="el-icon-time"></i>
          </div>
          <div class="card-content">
            <div class="card-title">平均时长</div>
            <div class="card-value">{{ summary.avgDuration }}</div>
            <div class="card-unit">分钟</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 图表区域 -->
    <el-row :gutter="20">
      <!-- 在线人数趋势 -->
      <el-col :span="24">
        <el-card class="chart-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>在线人数趋势</span>
            <el-radio-group v-model="granularity" size="mini" style="float: right;" @change="loadTrendData">
              <el-radio-button label="hour">按小时</el-radio-button>
              <el-radio-button label="day">按天</el-radio-button>
            </el-radio-group>
          </div>
          <div id="trendChart" style="height: 400px;"></div>
        </el-card>
      </el-col>
    </el-row>
    
    <!-- 卡类型统计区域 -->
    <el-row :gutter="20" style="margin-top: 20px;">
      <!-- 左侧：卡类型数量分布 -->
      <el-col :span="12">
        <el-card class="chart-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>购卡类型数量分布</span>
          </div>
          <div id="cardTypeChart" style="height: 400px;"></div>
        </el-card>
      </el-col>
      
      <!-- 右侧：卡类型金额分布 -->
      <el-col :span="12">
        <el-card class="chart-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>购卡类型金额分布</span>
          </div>
          <div id="cardAmountChart" style="height: 400px;"></div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 店铺列表 -->
    <el-card class="table-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>店铺在线详情</span>
        <div style="float: right; display: flex; align-items: center;">
          <el-input
            v-model="storeSearchName"
            placeholder="搜索店铺名称"
            size="small"
            clearable
            style="width: 200px; margin-right: 10px;"
            @clear="filterStoreList"
            @input="filterStoreList"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-button size="small" type="text" @click="loadStoreList">
            <i class="el-icon-refresh"></i> 刷新
          </el-button>
        </div>
      </div>
      <el-table :data="filteredStoreList" border stripe v-loading="loading">
        <el-table-column type="index" label="序号" width="60" align="center"/>
        <el-table-column prop="storeName" label="店铺名称" min-width="150"/>
        <el-table-column prop="currentOnline" label="当前在线" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.currentOnline > 0 ? 'success' : 'info'" size="small">
              {{ scope.row.currentOnline }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="todayPeak" label="今日峰值" width="100" align="center">
          <template slot-scope="scope">
            <span style="color: #E6A23C; font-weight: bold;">{{ scope.row.todayPeak }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="todayTotal" label="今日总数" width="100" align="center">
          <template slot-scope="scope">
            <span style="color: #409EFF;">{{ scope.row.todayTotal }}</span>
          </template>
        </el-table-column>
        <!-- 暂时隐藏操作列
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewDetail(scope.row)">
              <i class="el-icon-view"></i> 详情
            </el-button>
          </template>
        </el-table-column>
        -->
      </el-table>
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'OnlineStatistics',
  data() {
    return {
      searchForm: {
        storeId: null,
        timeRange: []
      },
      summary: {
        currentOnline: 0,
        todayPeak: 0,
        todayTotal: 0,
        avgDuration: 0
      },
      storeList: [],
      filteredStoreList: [],
      storeSearchName: '',
      stores: [],
      chart: null,
      cardTypeChart: null,
      cardAmountChart: null,
      granularity: 'hour',
      loading: false,
      searchLoading: false,
      timer: null
    };
  },
  mounted() {
    this.loadStores();
    this.loadSummary();
    this.loadStoreList();
    this.initChart();
    this.initCardTypeChart();
    this.initCardAmountChart();
    
    // 每30秒刷新一次实时数据
    this.timer = setInterval(() => {
      this.loadSummary();
      this.loadStoreList();
    }, 30000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.chart) {
      this.chart.dispose();
    }
    if (this.cardTypeChart) {
      this.cardTypeChart.dispose();
    }
    if (this.cardAmountChart) {
      this.cardAmountChart.dispose();
    }
  },
  methods: {
    // 加载店铺列表
    loadStores() {
      this.$http.get('/store/').then(res => {
        if (res.data.status === 0) {
          this.stores = res.data.data || [];
        }
      }).catch(err => {
        console.error('加载店铺列表失败', err);
      });
    },
    
    // 加载总览数据
    loadSummary() {
      this.$http.get('/store/online/total').then(res => {
        if (res.data.status === 0) {
          this.summary = res.data.data || {
            currentOnline: 0,
            todayPeak: 0,
            todayTotal: 0,
            avgDuration: 0
          };
        }
      }).catch(err => {
        console.error('加载总览数据失败', err);
      });
    },
    
    // 加载店铺在线列表
    loadStoreList() {
      this.loading = true;
      const params = {
        storeId: this.searchForm.storeId,
        storeName: this.searchForm.storeName
      };
      
      this.$http.get('/store/online/list', { params }).then(res => {
        if (res.data.status === 0) {
          this.storeList = res.data.data.list || [];
          this.filterStoreList();
        }
      }).catch(err => {
        console.error('加载店铺列表失败', err);
        this.$message.error('加载店铺列表失败');
      }).finally(() => {
        this.loading = false;
      });
    },
    
    // 过滤店铺列表
    filterStoreList() {
      if (!this.storeSearchName || this.storeSearchName.trim() === '') {
        this.filteredStoreList = this.storeList;
      } else {
        const keyword = this.storeSearchName.trim().toLowerCase();
        this.filteredStoreList = this.storeList.filter(store => 
          store.storeName && store.storeName.toLowerCase().includes(keyword)
        );
      }
    },
    
    // 初始化图表
    initChart() {
      this.chart = echarts.init(document.getElementById('trendChart'));
      this.loadTrendData();
    },
    
    // 加载趋势数据
    loadTrendData() {
      const params = {
        storeId: this.searchForm.storeId,
        granularity: this.granularity
      };
      
      if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
        params.startTime = this.searchForm.timeRange[0];
        params.endTime = this.searchForm.timeRange[1];
      }
      
      return this.$http.get('/store/online/trend', { params }).then(res => {
        if (res.data.status === 0) {
          const data = res.data.data.data || [];
          this.renderChart(data);
        }
      }).catch(err => {
        console.error('加载趋势数据失败', err);
        throw err;
      });
    },
    
    // 渲染图表
    renderChart(data) {
      const option = {
        title: {
          text: '在线人数趋势',
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: data.map(item => item.time),
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          type: 'value',
          name: '人数',
          minInterval: 1
        },
        series: [
          {
            name: '在线人数',
            type: 'line',
            data: data.map(item => item.count),
            smooth: true,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(64, 158, 255, 0.3)' },
                { offset: 1, color: 'rgba(64, 158, 255, 0.05)' }
              ])
            },
            itemStyle: {
              color: '#409EFF'
            },
            lineStyle: {
              width: 2
            }
          }
        ]
      };
      
      this.chart.setOption(option);
    },
    
    // 初始化卡类型图表
    initCardTypeChart() {
      this.cardTypeChart = echarts.init(document.getElementById('cardTypeChart'));
      this.loadCardTypeData();
    },
    
    // 加载卡类型统计数据
    loadCardTypeData() {
      const params = {
        storeId: this.searchForm.storeId
      };
      
      if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
        params.startTime = this.searchForm.timeRange[0];
        params.endTime = this.searchForm.timeRange[1];
      }
      
      return this.$http.get('/api/card-statistics/type-distribution', { params }).then(res => {
        if (res.data.code === 200) {
          const data = res.data.data || [];
          this.renderCardTypeChart(data);
        }
      }).catch(err => {
        console.error('加载卡类型统计失败', err);
        throw err;
      });
    },
    
    // 渲染卡类型饼图
    renderCardTypeChart(data) {
      const colors = [
        '#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de',
        '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'
      ];
      
      const option = {
        title: {
          text: '购卡类型分布',
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          top: 'middle',
          textStyle: {
            fontSize: 12
          }
        },
        color: colors,
        series: [
          {
            name: '卡类型',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['60%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '18',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: data.map(item => ({
              name: item.cardType,
              value: item.count
            }))
          }
        ]
      };
      
      this.cardTypeChart.setOption(option);
    },
    
    // 初始化卡金额图表
    initCardAmountChart() {
      this.cardAmountChart = echarts.init(document.getElementById('cardAmountChart'));
      this.loadCardAmountData();
    },
    
    // 加载卡金额分布数据
    loadCardAmountData() {
      const params = {
        storeId: this.searchForm.storeId
      };
      
      if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
        params.startTime = this.searchForm.timeRange[0];
        params.endTime = this.searchForm.timeRange[1];
      }
      
      return this.$http.get('/api/card-statistics/amount-distribution', { params }).then(res => {
        if (res.data.code === 200) {
          const data = res.data.data || [];
          this.renderCardAmountChart(data);
        }
      }).catch(err => {
        console.error('加载卡金额分布失败', err);
        throw err;
      });
    },
    
    // 渲染卡金额饼图
    renderCardAmountChart(data) {
      const colors = [
        '#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de',
        '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'
      ];
      
      const option = {
        title: {
          text: '卡类型金额分布',
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: function(params) {
            return params.name + '<br/>' +
                   '金额: ¥' + params.value.toFixed(2) + '<br/>' +
                   '占比: ' + params.percent.toFixed(1) + '%';
          }
        },
        legend: {
          orient: 'vertical',
          right: '10%',
          top: 'center',
          textStyle: {
            fontSize: 12
          }
        },
        color: colors,
        series: [
          {
            name: '金额分布',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['35%', '50%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: true,
              formatter: function(params) {
                if (params.value > 0) {
                  return params.name + '\n¥' + params.value.toFixed(0);
                }
                return '';
              },
              fontSize: 11
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true
            },
            data: data.map(item => ({
              name: item.cardType,
              value: item.amount
            }))
          }
        ]
      };
      
      this.cardAmountChart.setOption(option);
    },
    
    // 查询
    async handleSearch() {
      if (this.searchLoading) return;
      
      this.searchLoading = true;
      try {
        await Promise.all([
          this.loadStoreList(),
          this.loadTrendData(),
          this.loadCardTypeData(),
          this.loadCardAmountData()
        ]);
      } catch (error) {
        console.error('查询失败', error);
        this.$message.error('查询失败，请重试');
      } finally {
        this.searchLoading = false;
      }
    },
    
    // 重置
    handleReset() {
      this.searchForm = {
        storeId: null,
        timeRange: []
      };
      this.granularity = 'hour';
      this.handleSearch();
    },
    
    // 查看详情
    viewDetail(row) {
      this.$message.info('查看店铺详情：' + row.storeName);
      // TODO: 跳转到详情页或打开详情对话框
    }
  }
};
</script>

<style scoped>
.online-statistics {
  padding: 20px;
}

.search-card {
  margin-bottom: 20px;
}

.summary-cards {
  margin-bottom: 20px;
}

.summary-card {
  display: flex;
  align-items: center;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s;
}

.summary-card:hover {
  transform: translateY(-5px);
}

.card-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: white;
  margin-right: 20px;
}

.card-icon.current-online {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.card-icon.today-peak {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.card-icon.today-total {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.card-icon.avg-duration {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.card-content {
  flex: 1;
}

.card-title {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}

.card-value {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
  display: inline-block;
}

.card-unit {
  font-size: 14px;
  color: #909399;
  display: inline-block;
  margin-left: 5px;
}

.chart-card {
  margin-bottom: 20px;
}

.table-card {
  margin-bottom: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>
